<template>
  <div class="systemEnterNew">
    <ul class="flex">
      <template v-if="systemList.length > 0">
        <li
          class="flex-inline"
          v-for="(item, index) in systemList"
          :key="item.id + index"
          @click="systemEntrance(item)"
        >
          <span class="icon" v-if="item.icon?.indexOf('_YJ') > -1"
            ><i :class="['iconfontyj', item.icon]" style="font-size: 37px;"></i
          ></span>
          <span
            class="icon"
            v-if="item.icon?.indexOf?.('ivu-') == -1 && item.icon?.indexOf('_YJ') == -1"
            ><Icon :type="item.icon" size="37"></Icon
          ></span>
          <span
            class="icon"
            v-if="item.icon?.indexOf?.('ivu-') > -1 && item.icon?.indexOf('_YJ') == -1"
            ><Icon :custom="item.icon" size="37"></Icon
          ></span>
          <span class="name">{{ item.title }}</span>
          <Spin size="small" fix v-if="loading.showSpin === item.id"></Spin>
        </li>
      </template>
      <template v-else>
        <li class="nodata">
          <span class="name">暂无系统列表</span>
        </li>
      </template>
    </ul>
    <Modal
      style="top: 0"
      title="登录企业"
      v-model="show.organizationModal"
      class-name="vertical-center-modal"
      width="390"
    >
      <!-- <span slot="close" style="color: #FF8C00;line-height:34px;">取消</span> -->
      <!-- :asyncOption="true"  -->
      <selectRemote
        v-if="show.organizationModal"
        placeholder="请选择需要登录的企业"
        style="width: 100%; margin: 15px 0 20px"
        v-model="organization"
        :remote="true"
        :url="requestObj.selectionOrganizationBySystem.url"
        requestMethod="get"
        :paramter="requestObj.selectionOrganizationBySystem.data"
      ></selectRemote>
      <div slot="footer">
        <Button
          :disabled="!organization"
          type="primary"
          style="width: 160px"
          :loading="loading.enterSystem"
          @click="getInSystem"
          >进入系统</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import UrlUitls from 'pangu-components/static/js/urlUitls.js'
export default {
  name: 'systemEntrance',
  data() {
    return {
      transfer: false,
      loading: {
        //加载变量
        showSpin: '',
        enterSystem: false,
      },
      show: {
        //控制显示隐藏
        organizationModal: false,
      },
      //点击进入系统需要的信息:entry(url),ticket(string)
      curSystemInfo: {
        entry: '',
        ticket: '',
      },
      organization: '',
      organizationBySystem: [],
      systemList: [],
      requestObj: {
        // 获取系统列表
        // 表现为：首页右侧列表
        getSystemList: {
          url: 'rest/main/index/getSystemList',
          data: { platformCode: this.$store.state.user.platformCode },
        },
        // 获取对应系统下的组织
        // 表现为：点击右侧列表中的一个系统，查询此系统下对应的组织
        selectionOrganizationBySystem: {
          url: 'rest/main/index/selectionOrganizationBySystem',
          data: {
            systemId: '',
            systemAliasId: '.',
          },
        },
        //通过当前登陆系统token获取ticket
        //organizationCode:表现为：登陆企业模态框中选择一个系统点击进入系统时
        getTicketByToken: {
          url: 'rest/security/auth/getTicketByToken',
          data: {
            tokenId: '',
            organizationCode: '',
            systemCode: '',
            systemAliasCode: '',
          },
        },
      },
    }
  },
  mounted() {
    this.getSystemList()
  },
  methods: {
    getInSystem() {
      // 用当前系统的systemCode
      if (this.loading.enterSystem) return
      this.requestObj.getTicketByToken.data.organizationCode = this.organization
      this.requestObj.getTicketByToken.data.tokenId = this.$store.state.user.currentToken.id
      this.loading.enterSystem = true
      let that = this
      this.$axios
        .get(
          `${this.requestObj.getTicketByToken.url}?${UrlUitls.paramSerializer(
            this.requestObj.getTicketByToken.data
          )}`
        )
        .then((res) => {
          this.loading.enterSystem = false
          if (!this.$cfn.ajax1.isOK(res, this)) return
          let data = res.data.data
          if (data && data != '') {
            that.curSystemInfo.ticket = data
            var openUrl = UrlUitls.getFullUrl(
              `${that.curSystemInfo.entry}?ticket=${that.curSystemInfo.ticket}`
            )
            console.log(openUrl)
            var win1 = window.open(openUrl)
            if (!win1 || !win1.location) {
              that.$Message.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
            }
            this.show.organizationModal = false
          }
        })
        .catch((res) => {
          this.loading.enterSystem = false
          that.$cfn.ajax1.catch1(res, that)
        })
    },
    systemEntrance(systeminfo, specialSystem) {
      // 先清空systemId，让下拉重新获取值
      this.requestObj.selectionOrganizationBySystem.data.systemId = ''
      console.log(this.organization)
      if (this.loading.showSpin != '') return
      this.organization = '' //清空organization
      this.organizationBySystem.length = 0 //清空organizationBySystem
      this.loading.showSpin = systeminfo.id //显示加载动效
      this.curSystemInfo.entry = systeminfo.entry //获取进入系统的链接
      this.requestObj.getTicketByToken.data.systemCode = systeminfo.code //设置getTicketByToken的systemCode参数
      this.requestObj.getTicketByToken.data.systemAliasCode = systeminfo.alias.code //设置getTicketByToken的systemAliasCode参数
      this.requestObj.selectionOrganizationBySystem.data.systemId = systeminfo.id //设置selectionOrganizationBySystem的systemId参数
      this.requestObj.selectionOrganizationBySystem.data.systemAliasId = systeminfo.alias.id //设置selectionOrganizationBySystem的systemAliasId参数
      let that = this
      this.$axios
        .get(
          `${this.requestObj.selectionOrganizationBySystem.url}?${UrlUitls.paramSerializer(
            this.requestObj.selectionOrganizationBySystem.data
          )}`
        )
        .then((res) => {
          this.loading.showSpin = '' //移除加载动效
          if (!res.data.data) return
          let data = res.data.data
          if (data) {
            if (specialSystem && specialSystem === 'chain' && data.length >= 1) {
              that.organization = data[0].code //设置getTicketByToken的organizationCode参数
              that.getInSystem()
            } else {
              if (data.length === 1) {
                that.organization = data[0].code //设置getTicketByToken的organizationCode参数
                that.getInSystem()
              } else if (data.length > 1) {
                that.organizationBySystem = data
                that.show.organizationModal = true
              } else {
                getInSystem()
              }
            }
          } else {
            that.$Message.warn('暂无信息')
          }
        })
        .catch((res) => {
          this.loading.showSpin = '' //移除加载动效
          this.$cfn.ajax1.catch1(res, that)
        })
    },

    getSystemList() {
      let that = this
      this.$axios
        .get(
          `${this.requestObj.getSystemList.url}?${UrlUitls.paramSerializer(
            this.requestObj.getSystemList.data
          )}`
        )
        .then((res) => {
          console.log(this.requestObj.getSystemList.url)
          if (!this.$cfn.ajax1.isOK(res, this)) return
          let data = res.data.data
          if (data) {
            that.systemList = data
            that.chainRouter()
          }
        })
        .catch((res) => {
          return
        })
    },

    // 查找如果授权了16订货系统就自行跳转
    chainRouter() {
      // 第一次登录就跳转，如果是刷新，就不跳转了
      if (this.$route.query.CHAIN_JUMP) {
        sessionStorage.setItem(`${this.GLOBAL.cacheKey}_CHAIN_JUMP`, true)
        delete this.$route.query.CHAIN_JUMP
        return false
      }
      let sessionValue = sessionStorage.getItem(`${this.GLOBAL.cacheKey}_CHAIN_JUMP`)
      if (sessionValue) return false
      let systeminfo = null
      // 从系统列表中筛选，如果有16订货系统，就自动跳转,其实可以根据systemCode来判断，但是16订货的服务器是另外的，所以肯定不会授权灵科优联
      // 麻烦的就是如果是开发环境，就会自动跳了
      // 从系统列表中找到CHAIN系统的信息
      if (this.systemList && this.systemList.length > 0) {
        systeminfo = this.systemList.find((im) => {
          if (im.code == 'CHAIN') return im
        })
      }
      if (systeminfo) {
        // 如果找到了16订货系统，就记录一个变量，总不能每次进个人中心都跳转到系统里呀，所以，就跳转一次
        // 虽然用localStorage，但是我需要在系统或者页面关闭的时候，要把这个参数给他删除掉，用localStorage是为了防止刷新值丢失的问题所以不用sessionStorage
        sessionStorage.setItem(`${this.GLOBAL.cacheKey}_CHAIN_JUMP`, true)
        this.systemEntrance(systeminfo, 'chain')
      }
    },
  },
}
</script>
